import actionTypes from '../constants/action-types';

const setOpen = (value) => ({
  type: actionTypes.SET_OPEN,
  payload: { value },
});

export default setOpen;
